import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lib-ui-notification-empty-state',
  templateUrl: './ui-notification-empty-state.component.html',
  styleUrl: './ui-notification-empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNotificationEmptyStateComponent {
  @Input() title = 'Tudo em ordem';
  @Input() description =
    'As próximas notificações em tempo real vão aparecer aqui.';
}
